import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '@shared/i18n/config';
import { RTL_LANGUAGES } from '@shared/i18n/config';
export function I18nProvider({ children }) {
    useEffect(() => {
        const handleLanguageChange = (lng) => {
            document.documentElement.lang = lng;
            document.documentElement.dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr';
        };
        // Set initial values
        const currentLang = i18n.language;
        handleLanguageChange(currentLang);
        // Subscribe to language changes
        i18n.on('languageChanged', handleLanguageChange);
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);
    return _jsx(I18nextProvider, { i18n: i18n, children: children });
}
